module.exports = __webpack_public_path__ + "static/media/settings-icon.f23ea576.svg";